import { capitalizeFirstLetter } from "@/lib/utils";
import { CrmType } from "@/types";

export const mapCRMName = (crmName: string): string => {
  switch (crmName) {
    case CrmType.PARAGON_MICROSOFTDYNAMICS:
      return "Microsoft Dynamics";
    case CrmType.PARAGON_ZOHO:
      return "Zoho";
    case CrmType.PARAGON_CLOVEN:
      return "Cloven";
    case CrmType.SALESFORCE:
    case CrmType.PARAGON_SALESFORCE:
      return "Salesforce";
    case CrmType.REDTAIL:
      return "Redtail";
    case CrmType.WEALTHBOX:
      return "Wealthbox";
    case CrmType.PARAGON_FSC:
      return "Salesforce FSC";
    case CrmType.PARAGON_XLR8:
      return "XLR8";
    case CrmType.PARAGON_PRACTIFI:
      return "Practifi";
    case CrmType.PARAGON_SS_C_BLACKDIAMONDELEMENTS:
      return "SS&C Black Diamond Elements";
    case CrmType.PARAGON_MAXIMIZER:
      return "Maximizer";
    case CrmType.PARAGON_EQUISOFT:
      return "Equisoft";
    case CrmType.LAYLAH:
      return "Laylah";

    default:
      return capitalizeFirstLetter(crmName?.toLowerCase());
  }
};
